import {ArgValidator} from 'neo-common';
import {BetType} from './BetType';

/**
 * @class SpinBet - information about spin bet.
 */
export class SpinBet {
    /**
     * @property betType - Type of bet for slot.
     */
    betType: BetType;

    /**
     * @property coinSize - Value represents amount of cents.
     * Sent only when @betType is Payline.
     */
    coinSize: number;

    /**
     * @property coinCount - List of available coin counts.
     * Sent only when @betType is Payline.
     */
    coinCount: number;

    /**
     * @property paylineCount - Count of paylines included in bet.
     * Sent only when @betType is Payline.
     */
    paylineCount: number;

    /**
     * @totalBet - Value represents amount of cents.
     * Sent only when @betType is Total.
     */
    totalBet: number;

    constructor(betType?: any, coinSize?: number, coinCount?: number, paylineCount?: number, totalBet?: number) {
        this.betType = betType || (typeof coinSize === 'number' ? BetType.Payline : BetType.Total);
        this.coinSize = coinSize;
        this.coinCount = coinCount;
        this.paylineCount = paylineCount;
        this.totalBet = totalBet;

        if (this.betType === BetType.Payline) {
            ArgValidator.ensureIsNumber(coinSize, 'coinSize');
            ArgValidator.ensureIsNumber(coinCount, 'coinCount');
            ArgValidator.ensureIsNumber(paylineCount, 'paylineCount');
        } else {
            if(coinSize != null && coinCount != null) {
                ArgValidator.ensureIsNumber(coinSize, 'coinSize');
                ArgValidator.ensureIsNumber(coinCount, 'coinCount');
            } else {
                ArgValidator.ensureIsNumber(totalBet, 'totalBet');
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/SpinBet.ts
 **/